/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Sc_PaletteInputs */

const en_pc_tut_sc_palette = /** @type {(inputs: Pc_Tut_Sc_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command palette`)
};

const zh_pc_tut_sc_palette = /** @type {(inputs: Pc_Tut_Sc_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令面板`)
};

/**
* | output |
* | --- |
* | "Command palette" |
*
* @param {Pc_Tut_Sc_PaletteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_sc_palette = /** @type {((inputs?: Pc_Tut_Sc_PaletteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Sc_PaletteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_sc_palette(inputs)
	return zh_pc_tut_sc_palette(inputs)
});
export { pc_tut_sc_palette as "pc.tut.sc.palette" }